export default "__VITE_ASSET__CWbYnLMn__"